import { Link } from "react-router-dom";
import { MessageCircle, Mail, Instagram, MapPin } from "lucide-react";
import { buildWaLink } from "@/lib/whatsapp";

const LINKS = [
  { label: "Master Models", to: "/category/master-models" },
  { label: "Finished Products", to: "/category/finished-products" },
  { label: "Dashboard Idols", to: "/category/dashboard-idols" },
  { label: "Miniatures", to: "/category/miniatures" },
  { label: "STL Files", to: "/category/stl-files" },
  { label: "Silicone Molds", to: "/category/silicone-molds" },
];

export const Footer = ({ settings }) => (
  <footer data-testid="footer" className="bg-[#222222] text-white mt-16 md:mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
      <div className="sm:col-span-2 lg:col-span-1">
        <span className="font-heading font-extrabold text-2xl gg-gradient-text">GlowinGifts</span>
        <p className="mt-4 text-sm text-white/60 leading-relaxed">
          Premium resin 3D printing — high-detail God idols, master models for mold makers, and devotional collectibles. Made in India with devotion.
        </p>
      </div>
      <div>
        <h3 className="font-heading font-semibold text-sm uppercase tracking-widest text-[#F5B301]">Shop</h3>
        <ul className="mt-4 space-y-2.5">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-sm text-white/60 hover:text-white transition-colors">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h3 className="font-heading font-semibold text-sm uppercase tracking-widest text-[#F5B301]">Company</h3>
        <ul className="mt-4 space-y-2.5">
          <li><Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors">About Us</Link></li>
          <li><Link to="/contact" className="text-sm text-white/60 hover:text-white transition-colors">Contact</Link></li>
          <li><Link to="/categories" className="text-sm text-white/60 hover:text-white transition-colors">All Categories</Link></li>
          <li><Link to="/cart" className="text-sm text-white/60 hover:text-white transition-colors">Cart</Link></li>
        </ul>
      </div>
      <div>
        <h3 className="font-heading font-semibold text-sm uppercase tracking-widest text-[#F5B301]">Get in Touch</h3>
        <ul className="mt-4 space-y-3">
          <li>
            <a
              href={buildWaLink(settings?.whatsapp_number || "919999999999", "Hello GlowinGifts!")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-2 text-sm text-white/60 hover:text-[#2EBD59] transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp Us
            </a>
          </li>
          <li className="flex items-center gap-2 text-sm text-white/60">
            <Mail size={16} /> {settings?.email || "hello@glowingifts.in"}
          </li>
          <li className="flex items-center gap-2 text-sm text-white/60">
            <Instagram size={16} /> @glowingifts
          </li>
          <li className="flex items-center gap-2 text-sm text-white/60">
            <MapPin size={16} /> Made in India
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-white/40">© {new Date().getFullYear()} GlowinGifts. All rights reserved.</p>
        <p className="text-xs text-white/40">Crafted with precision • Resin 3D Printing</p>
      </div>
    </div>
  </footer>
);

export default Footer;
